import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { ApiBusinessService } from 'src/app/services/api-business.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CheckoutService } from 'src/app/services/checkout.service';
import { CountdownService } from 'src/app/services/countdown.service';
import { ShoppingCartService } from 'src/app/services/shopping-cart.service';
import { TicketsService } from 'src/app/services/tickets.service';
import { ConfirmPayComponent } from '../../checkout/confirm-pay/confirm-pay.component';
import { WaitingPayComponent } from '../../checkout/waiting-pay/waiting-pay.component';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { InfoConditionsComponent } from '../info-conditions/info-conditions.component';
import { ConfirmPayTotemComponent } from '../../checkout/confirm-pay-totem/confirm-pay-totem.component';
import { TotemInfoComponent } from '../../checkout/totem-info/totem-info.component';
import { SelectMethodTotemComponent } from '../../checkout/select-method-totem/select-method-totem.component';
import { DiscountService } from 'src/app/services/discount.service';
import { PROMO_CODE_ERRORS } from 'src/app/interfaces/discount';
import { CHANNEL_ID } from 'src/app/config/channels';

@Component({
  selector: 'app-cart-checkout',
  templateUrl: './cart-checkout.component.html',
  styleUrls: ['./cart-checkout.component.scss']
})
export class CartCheckoutComponent implements OnInit, OnDestroy {

  shoppingCartUser!: any[];
  idCart!: number;
  loaded: boolean = false;
  urlImages: string = AppSettings.MEDIA_URI + '/events_images/';

  // Promo code v2 toggle
  openFormDiscount: boolean = false;

  // Promo codes (new v2)
  promoCode: string = '';
  appliedPromoCode: string | null = null;
  promoDiscountDisplayName: string | null = null;
  promoCodeError: string = '';
  applyingPromoCode: boolean = false;
  promoDiscountTotal: number = 0;
  appliedDiscounts: any = null;

  // Pass grouping
  passGroups: Map<number, any> = new Map();
  abonoDiscountTotal: number = 0;
  abonoDiscountName: string | null = null;

  showDiscountDetail: boolean = false;
  discountLines: { name: string; total: number }[] = [];

  lessExpiration!: any;
  countdown: any;
  openDetail!: number;
  totalPrice: number = 0;
  gestionPrice: number = 0;
  totalTickets: number = 0;
  totalDiscount: number = 0;

  subscriber!: any;
  subscriptionCountDown!: any;
  invoiceLines: any[] = [];
  bookings: any[] = [];
  profile!: any;
  isProtocolUser!: any;
  organizerEvents: any[];
  eventsCart: any[] = [];

  waiting: boolean = false;

  business!: any;
  paymentMethod!: any;

  @ViewChild('btn_submit') btn_submit: ElementRef;
  Ds_MerchantParameters: string;
  Ds_Signature: string;
  Ds_SignatureVersion: string;
  url: string;

  activePayRedsys: boolean = false;
  errorApi: boolean = false;
  isAdmin: boolean = false;

  checkAcceptConditions: boolean = false;
  checkConditionsCompany: boolean = false;
  companyGeneralConditions: string | null = null;
  citylokPaymentMethodsDisabled: boolean = false;

  totemActive: any = AppSettings.ENV_TOTEM;

  redsysMethod: 'card' | 'xpay' | 'bizum' = 'card';

  subscriberPrice!: any;
  subscriberUser!: any;
  subscribeClear!: any;
  subscribeDelete!: any;
  cart!: any;
  lessExpirationLine!: number;

  constructor(private shoppingCartService: ShoppingCartService, private dialog: MatDialog, private auth: AuthenticationService,
    private countdownService: CountdownService, private router: Router, private ticketsService: TicketsService,
    private checkoutService: CheckoutService, private location: Location, private apiBusiness: ApiBusinessService,
    private discountService: DiscountService, private cdr: ChangeDetectorRef, private ngZone: NgZone) { }

  ngOnInit(): void {
    this.profile = this.auth.getProfile();
    this.isAdmin = this.profile?.roleFunctions?.length > 0;
    this.checkCartBooking();
  }

  ngAfterViewInit() {
  }

  checkCartBooking() {
    this.waiting = true;
    this.bookings = [];
    // this.subscriberUser = this.auth.getMyData().subscribe({
    //   next: (data) => {
    //     this.organizerEvents = data.organizerEvents.map(value => value.id);
    this.getCartCheckout();
    //   }
    // });
  }

  getCartCheckout() {
    // Llamar sin ID para que el backend cargue todas las relaciones correctamente
    this.subscriber = this.shoppingCartService.getCartUser().subscribe({
      next: (res) => {
        this.cart = res.data?.cart;
        if (!this.cart) {
          this.waiting = false;
          this.loaded = true;
          return;
        }
        // if (res.data.cart.ttl < 0 && location.href.indexOf('cart-checkout') != -1 && res.data.cart.cart_lines.length > 0) {
        //   this.waiting = false;
        //   this.loaded = true;
        //   this.dialog.open(InfoCardComponent, {
        //     panelClass: 'info-dialog',
        //     data: {
        //       icon: false,
        //       text: 'Algunas de tus entradas ya no están disponibles',
        //       btnCancel: false
        //     }
        //   });
        //   return;
        // }

        this.shoppingCartService.setModifyCart(res.data.cart);
        if (this.cart && this.cart.cart_lines.length > 0) {

          this.getInfoCart();
        } else {
          // Carrito vacío, limpiar y actualizar estados
          this.shoppingCartUser = [];
          this.totalPrice = 0;
          this.gestionPrice = 0;
          this.totalDiscount = 0;
          this.waiting = false;
          this.loaded = true;
        }
      }, error: (err) => {
        this.subscriber?.unsubscribe();
        // Carrito vacío, limpiar y actualizar estados
        this.shoppingCartUser = [];
        this.totalPrice = 0;
        this.gestionPrice = 0;
        this.totalDiscount = 0;
        this.waiting = false;
        this.loaded = true;
      }
    });
  }

  getInfoCart() {
    this.shoppingCartUser = [];
    this.countdown = null;
    this.loaded = false;
    this.idCart = this.cart?.id;

    if (this.cart.cart_lines.length > 0) {
      const ticketsCart = this.cart.cart_lines.sort((a: any, b: any) => {
        return b.session.start_date - a.session.start_date;
      });
      this.countdown = this.cart.ttl;
      let linesByEventSession = [];

      // Usar total_order del API como fuente de verdad
      const totalOrder = this.cart.total_order;
      if (totalOrder) {
        this.totalPrice = totalOrder.total;
        this.gestionPrice = totalOrder.fee_total;
        this.totalDiscount = totalOrder.discount_total;
      } else {
        this.totalPrice = 0;
        this.gestionPrice = 0;
        this.totalDiscount = 0;
      }

      // Extraer descuentos de applied_discounts, agrupar por id_discount
      this.abonoDiscountTotal = 0;
      this.abonoDiscountName = null;
      this.discountLines = [];
      const appliedDiscounts: any[] = this.cart.applied_discounts || [];

      const grouped = new Map<number, { name: string; total: number }>();
      appliedDiscounts.forEach((d: any) => {
        const key = d.id_discount;
        if (grouped.has(key)) {
          grouped.get(key)!.total += d.discount_total || 0;
        } else {
          grouped.set(key, { name: d.public_name || d.name, total: d.discount_total || 0 });
        }
      });
      this.discountLines = Array.from(grouped.values());

      const abonoDiscounts = appliedDiscounts.filter((d: any) => d.rule_type === 'pass');
      if (abonoDiscounts.length > 0) {
        this.abonoDiscountTotal = abonoDiscounts.reduce((sum: number, d: any) => sum + (d.discount_total || 0), 0);
        this.abonoDiscountName = abonoDiscounts[0].public_name || abonoDiscounts[0].name;
      }

      ticketsCart.forEach(line => {
        const lineTotal = line.total ?? +line.price;
        const lineFee = line.fee_total ?? +line.fee;
        const discountAmount = line.discount_total || 0;
        const abono = line.discount?.rule_type === 'pass' ? line.discount : null;

        if (!totalOrder) {
          this.totalPrice += lineTotal;
          this.gestionPrice += lineFee;
        }

        // price_original ya es el total de la linea (suma de todas las bookings), no el precio unitario
        const lineOriginalPrice = line.price_original ?? +line.price;
        const ticketEntry = { ticket: line.ticket, quantity: +line.quantity, price: lineTotal, originalPrice: line.price_original ?? +line.price, fee: lineFee, booking: line.bookings[0], id_line: line.id, abono, discountAmount };

        let existEvent = linesByEventSession.find(value => value.id_event == line.id_event);
        if (existEvent) {
          let existSession = existEvent.lines.find((value: any) => value.session.id == line.session.id);
          if (existSession) {
            existSession.quantity_session += +line.quantity;
            existSession.price += lineTotal;
            existSession.originalPrice += lineOriginalPrice;
            existSession.fees += lineFee;
            existSession.discountAmount = (existSession.discountAmount || 0) + discountAmount;
            existSession.tickets.push(ticketEntry);
          } else {
            existEvent.lines.push({
              session: line.session,
              quantity_session: +line.quantity,
              price: lineTotal,
              originalPrice: lineOriginalPrice,
              fees: lineFee,
              discountAmount,
              tickets: [ticketEntry]
            });
          }
          existEvent.price += lineTotal;
          existEvent.originalPrice += lineOriginalPrice;
          existEvent.fees += lineFee;
          existEvent.quantity_event += +line.quantity;
        } else {
          linesByEventSession.push({
            id_event: line.id_event,
            event: line.event,
            price: lineTotal,
            originalPrice: lineOriginalPrice,
            fees: lineFee,
            quantity_event: +line.quantity,
            lines: [{
              session: line.session,
              quantity_session: +line.quantity,
              price: lineTotal,
              originalPrice: lineOriginalPrice,
              fees: lineFee,
              discountAmount,
              tickets: [ticketEntry]
            }]
          });
        }
      });

      // Asignar dentro de NgZone para forzar detección de cambios
      this.ngZone.run(() => {
        this.shoppingCartUser = linesByEventSession;

        // Build pass groups for visual grouping
        this.passGroups = new Map();
        ticketsCart.forEach(line => {
          const passId = line.id_discount || line.id_pass;
          const passObj = line.discount || line.pass;
          if (passId && passObj) {
            if (!this.passGroups.has(passId)) {
              this.passGroups.set(passId, {
                pass: passObj,
                lines: []
              });
            }
            this.passGroups.get(passId).lines.push(line);
          }
        });
      });

      // Process promo code from cart
      this.processPromoCode();

      // let date = new Date();
      // date.setTime(date.getTime() + (this.cart.ttl * 1000));
      // this.lessExpiration = date;
      this.getFirstExpirationDate(this.cart.cart_lines);

      const company = this.cart.cart_lines[0].event.company;
      this.companyGeneralConditions = company?.general_conditions || null;
      this.checkConditionsCompany = false;
      this.citylokPaymentMethodsDisabled = !company?.payment_method_citylok;
      if (this.citylokPaymentMethodsDisabled && this.redsysMethod !== 'card') {
        this.redsysMethod = 'card';
      }
      this.loaded = true;
      this.waiting = false;
    } else {
      this.loaded = true;
      this.waiting = false;
    }

    // Forzar detección de cambios después de actualizar estados
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }

  getFirstExpirationDate(arrayTickets: any[]) {
    let expirationDate = null
    arrayTickets.forEach(element => {
      let date = new Date(element.created_at);
      if (expirationDate == null || expirationDate < date) {
        expirationDate = date;
        this.lessExpirationLine = element.id;
      }
    });
    // Calcular lessExpiration como la fecha de expirationDate + 15 minutos
    expirationDate.setMinutes(expirationDate.getMinutes() + 15);
    this.lessExpiration = expirationDate;
    this.getCountDown();
  }

  getCountDown() {
    this.countdown = this.countdownService.getInitialCountDown(this.lessExpiration.getTime());
    this.subscriptionCountDown = this.countdownService.getCountDown(this.lessExpiration.getTime()).subscribe((count: any) => {
      this.countdown = count;
      if ((count.minutes == 0 && count.seconds == 0) || count.days < 0) {
        this.subscriptionCountDown.unsubscribe();
        this.clearShoppingCart();
        this.shoppingCartService.setModifyCart(true);
        // this.deleteItemCart({ id_line: this.lessExpirationLine });
        // this.getCartCheckout();
      }
    })
  }

  openEvent(id: number, name: string) {
    this.router.navigate([`/event/${id}-${name.replaceAll(' ', '-')}`]);
  }

  goBack() {
    const previousUrl = document.referrer;

    if (previousUrl && !previousUrl.includes('checkout')) {
      this.location.back();
    } else {
      this.router.navigate(['/']); // redirige a la home u otra ruta segura alternativa
    }
  }

  deleteAllEvent(items: any[]) {
    this.waiting = true;
    let ids = [];
    let existAbono: boolean = false;
    let idsAbono = [];
    items.forEach(value => {
      let ticketsBono = value.tickets.filter((value) => value.abono);
      idsAbono.push(...ticketsBono.map((value) => value.abono.id));
      if (ticketsBono.length > 0) {
        existAbono = true;
      }
      ids.push(...value.tickets.map(el => el.id));
    });
    if (existAbono) {
      const dialogRef = this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: true,
          text: '¡Existe un abono en alguna de las entradas, ¿estás seguro de que deseas eliminarlas? El resto de entradas que contengan ese abono se eliminarán también.',
          btnCancel: true
        }
      });
      dialogRef.afterClosed().subscribe({
        next: (result) => {
          if (result) {
            this.shoppingCartUser.forEach(element => {
              element.options.forEach(option => {
                option.tickets.forEach(ticket => {
                  if (ticket.abono && idsAbono.includes(ticket.abono.id)) {
                    if (!ids.includes(ticket.id)) {
                      ids.push(ticket.id);
                    }
                  }
                });
              });
            });
            this.deleteItemCart(ids);
          } else {
            this.waiting = false;
          }
        }
      });
    } else {
      this.deleteItemCart(ids);
    }
  }

  deleteItemCart(item: any) {
    this.waiting = true;
    // Si tiene abono, mostrar mensaje de confirmación
    if (item.abono) {
      const dialogRef = this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: true,
          text: '¡Existe un abono en alguna de las entradas, ¿estás seguro de que deseas eliminarlas? El resto de entradas que contengan ese abono se eliminarán también.',
          btnCancel: true
        }
      });
      dialogRef.afterClosed().subscribe({
        next: (result) => {
          if (result) {
            // El backend se encarga de eliminar todas las cart_lines con el mismo abono
            this.deleteItemToCart(item.id_line);
          } else {
            this.waiting = false;
          }
        }
      });
    } else {
      this.deleteItemToCart(item.id_line);
    }
  }

  deleteItemToCart(idLine: number) {
    this.subscribeDelete = this.shoppingCartService.deleteItemToCart(idLine).subscribe({
      next: () => {
        // Pequeño delay para que el backend actualice correctamente
        setTimeout(() => {
          this.checkCartBooking();
        }, 300);
        this.subscribeDelete.unsubscribe();
      }, error: (err) => {
        this.subscribeDelete.unsubscribe();
        if (this.isClosedCartError(err)) {
          this.onClosedCart();
          return;
        }
        this.waiting = false;
      }
    })
  }

  /**
   * El back responde `not_open_cart` cuando el pedido de este carrito ya se ha
   * creado o cobrado (por ejemplo, en otra pestaña o al volver de Redsys a otro
   * dominio). Pasa al pagar (422) y al quitar líneas o tocar el código
   * promocional (409).
   */
  private isClosedCartError(err: any): boolean {
    return err?.error?.message === 'not_open_cart';
  }

  /**
   * Avisar y recargar en vez de dejar en pantalla un carrito que ya no se puede
   * tocar: en prod un usuario reintentó el pago, quitó la entrada y la volvió a
   * comprar, y se le cobró dos veces.
   */
  private onClosedCart() {
    this.waiting = false;
    this.shoppingCartService.setModifyCart(true);
    this.openInfoCard(this.totemActive
      ? 'Este pedido ya se ha procesado.'
      : 'Este pedido ya se ha procesado. Antes de volver a comprar, revisa tu correo y el apartado Mis compras de tu perfil.');
    this.checkCartBooking();
  }

  showDetailTickets(eventId: number) {
    this.openDetail = this.openDetail == eventId ? null : eventId;
  }



  // ===== Promo Code v2 Methods =====

  processPromoCode() {
    if (this.cart.promo_code) {
      this.appliedPromoCode = this.cart.promo_code;
      // El total ya viene descontado en total_order.total — solo necesitamos el importe para mostrarlo
      const appliedDiscounts: any[] = this.cart.applied_discounts || [];
      const promoDiscounts = appliedDiscounts.filter((d: any) => d.promo_code);
      if (promoDiscounts.length > 0) {
        this.promoDiscountTotal = promoDiscounts.reduce((sum: number, d: any) => sum + (d.discount_total || 0), 0);
        const promoDiscount = promoDiscounts[0];
        this.promoDiscountDisplayName = promoDiscount.public_name ?? promoDiscount.name ?? this.cart.promo_code;
      } else {
        // Fallback: discount_total del carrito menos los descuentos de abono ya procesados
        const cartDiscountTotal = parseFloat(this.cart.discount_total || '0');
        this.promoDiscountTotal = Math.max(0, cartDiscountTotal - this.abonoDiscountTotal);
        this.promoDiscountDisplayName = this.cart.promo_code;
      }
    } else {
      this.appliedPromoCode = null;
      this.promoDiscountTotal = 0;
      this.appliedDiscounts = null;
      this.promoDiscountDisplayName = null;
    }
  }

  applyPromoCodeV2() {
    if (!this.promoCode?.trim() || this.applyingPromoCode) return;
    this.applyingPromoCode = true;
    this.promoCodeError = '';

    this.discountService.applyPromoCode(this.idCart, this.promoCode.trim(), CHANNEL_ID.web).subscribe({
      next: () => {
        this.applyingPromoCode = false;
        this.promoCode = '';
        // Refrescar el carrito desde el backend para reflejar el descuento aplicado
        this.getCartCheckout();
      },
      error: (err) => {
        this.applyingPromoCode = false;
        if (this.isClosedCartError(err)) {
          this.onClosedCart();
          return;
        }
        const serverMsg = err.error?.message || '';
        this.promoCodeError = PROMO_CODE_ERRORS[serverMsg] || 'No se pudo aplicar el código promocional';
      }
    });
  }

  removePromoCodeV2() {
    if (this.applyingPromoCode) return;
    this.applyingPromoCode = true;

    this.discountService.removePromoCode(this.idCart).subscribe({
      next: () => {
        this.applyingPromoCode = false;
        // Refrescar el carrito desde el backend para reflejar la eliminación del descuento
        this.getCartCheckout();
      },
      error: (err) => {
        this.applyingPromoCode = false;
        if (this.isClosedCartError(err)) {
          this.onClosedCart();
        }
      }
    });
  }

  selectPaymentMethod(method: 'card' | 'xpay' | 'bizum') {
    if (method !== 'card' && this.citylokPaymentMethodsDisabled) {
      return;
    }
    this.redsysMethod = method;
  }

  openPlatformBuy() {
    this.waiting = true;
    // this.getInvoice();
    let fees = (Math.round(this.gestionPrice * 100) / 100).toFixed(2);
    let object = { totalPrice: this.totalPrice, fees: +fees, cart: this.cart.id, discount: null, tickets: this.shoppingCartUser };
    if (this.loaded) {
      this.waiting = false;
      const paymentMethod = this.totemActive ? 'totem' : 'web';
      const redsysMethod = this.totemActive ? 'card' : this.redsysMethod;
      // Llamada de pago para obtener url de redirección
      this.checkoutService.generateOrder(this.cart.id, paymentMethod, redsysMethod).subscribe({
        next: (data) => {
          // return;
          this.activePayRedsys = true;
          const paymentData = data.data['tpv_order']['payment_data'];
          const isRedsys = !!paymentData?.Ds_MerchantParameters && !this.totemActive;
          if (isRedsys && this.totalPrice != 0) {
            this.Ds_MerchantParameters = paymentData['Ds_MerchantParameters'];
            this.Ds_Signature = paymentData['Ds_Signature'];
            this.Ds_SignatureVersion = paymentData['Ds_SignatureVersion'];
            this.url = paymentData['url'];

            const form = document.createElement('form');
            form.method = 'POST';
            form.action = this.url;
            const dsSignatureVersion = document.createElement('input');
            dsSignatureVersion.type = 'hidden';
            dsSignatureVersion.name = 'Ds_SignatureVersion';
            dsSignatureVersion.value = this.Ds_SignatureVersion;

            const dsMerchantParameters = document.createElement('input');
            dsMerchantParameters.type = 'hidden';
            dsMerchantParameters.name = 'Ds_MerchantParameters';
            dsMerchantParameters.value = this.Ds_MerchantParameters;

            const dsSignature = document.createElement('input');
            dsSignature.type = 'hidden';
            dsSignature.name = 'Ds_Signature';
            dsSignature.value = this.Ds_Signature;

            form.appendChild(dsSignatureVersion);
            form.appendChild(dsMerchantParameters);
            form.appendChild(dsSignature);

            // Guardar el order.id real de Laravel para recuperarlo al volver de Redsys
            // (la URL de retorno solo trae id_cart/Ds_Order, no el order.id que necesita el diálogo)
            localStorage.setItem('redsys_pending_order_id', data.data.order.id);

            // Y el evento, para que un pago fallido devuelva a él (solo si es uno).
            // Mismo slug que en la home y las tarjetas: la columna slug va vacía.
            const events = [...new Map(this.cart.cart_lines.filter((line: any) => line.event)
              .map((line: any) => [line.event.id, line.event])).values()] as any[];
            if (events.length === 1) {
              localStorage.setItem('redsys_pending_event_slug', events[0].id + '-' + (events[0].title || '').replaceAll(' ', '-'));
            } else {
              localStorage.removeItem('redsys_pending_event_slug');
            }

            document.body.appendChild(form);
            form.submit();

            this.waiting = false;
          }
          else if (!isRedsys) {
            if (this.totemActive) {
              if (this.totalPrice == 0) {
                this.shoppingCartService.setModifyCart(true);
                this.openDialogsTotem(data);
                this.waiting = false;
              }
              else {
                const order_uuid = data.data.order.id;
                const dialogRef = this.dialog.open(WaitingPayComponent, {
                  panelClass: 'info-dialog',
                  data: { order_uuid: order_uuid, id_business_citylok: this.business?.id_citylok },
                  disableClose: true
                })
                dialogRef.afterClosed().subscribe(result => {
                  this.waiting = true;
                  if (result && result['status'] == 'SUCCESS') {
                    // Limpiar el carrito inmediatamente después del pago exitoso
                    this.shoppingCartService.setModifyCart(true);
                    this.openDialogsTotem(data);

                    this.waiting = false;
                  } else {
                    this.waiting = false;
                    this.openInfoCard('¡Vaya! Ha ocurrido un error y no se puede procesar el pago. Puedes contactar con nosotros a través del email hola@citylok.com.');
                  }
                })
              }

            } else {
              if (data.data) {
                object['order'] = data.data;
                if (this.totalPrice == 0) {
                  const idOrder = data.data.order.id;
                  this.freeOrder(idOrder);
                  return;
                }
                this.router.navigate(['/checkout/validate'], { state: object });
              } else {
                this.waiting = false;
                this.openInfoCard('Ha ocurrido un error al procesar el pago, por favor, inténtelo de nuevo más tarde.');
              }
            }
          }
          else if (this.totalPrice == 0 && data.data) {
            const idOrder = data.data.order.id;
            this.freeOrder(idOrder);
            return;
          } else {
            this.waiting = false;
            this.openInfoCard('Ha ocurrido un error al procesar el pago, por favor, inténtelo de nuevo más tarde.');
          }
        }, error: (err) => {
          console.error("Error pago", err);
          this.waiting = false;
          if (this.isClosedCartError(err)) {
            this.onClosedCart();
          } else if (err.status == 503) {
            this.openInfoCard
              ('El dispositivo de pago no está disponible, por favor, inténtelo de nuevo.');
          } else {
            if (this.totemActive) {
              this.openInfoCard('¡Vaya! Ha ocurrido un error al procesar la compra, por favor, vuelve a intentarlo. También puedes contactar con nosotros a través del email hola@citylok.com.');
              return;
            }
            this.openInfoCard('Ha ocurrido un error al procesar el pago, por favor, inténtelo de nuevo más tarde.');
          }

        }
      });
    }
  }

  freeOrder(idOrder: any) {
    this.shoppingCartUser = null;
    // Notificar que el carrito ha sido limpiado
    this.shoppingCartService.setModifyCart(true);
    const dialogRef = this.dialog.open(ConfirmPayComponent, {
      panelClass: 'info-dialog',
      data: {
        idOrder: idOrder
      }
    });
    this.waiting = false;
    dialogRef.afterClosed().subscribe({
      next: (data) => {
        let url = !this.isAdmin ? '/profile' : '/panel-control/orders/list';
        if (data.print) {
          // Comprobar si es gestor y mandar a pedidos
          this.router.navigate([url]).then(() => {
            let text = 'Se han descargado las entradas correctamente.';
            this.openInfoCard(text);
          });
        } else {
          this.router.navigate([url]).then(() => {
            this.openInfoCard('El pago se ha realizado correctamente. Podrás consultar las entradas en tu correo electrónico o en el apartado Mis compras de tu perfil.');
          });
        }
      }
    })
  }

  openDialogsTotem(result: any) {
    this.subscriber?.unsubscribe();
    const dialogRef = this.dialog.open(TotemInfoComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        const dialogMethod = this.dialog.open(SelectMethodTotemComponent, {
          panelClass: 'info-dialog',
          disableClose: true,
          data: { total_order: this.totalPrice, total_fee: this.gestionPrice, order: result.data.order.id },
        });
        dialogMethod.afterClosed().subscribe({
          next: (selected) => {
            const method = selected
            const dialogMethod = this.dialog.open(ConfirmPayTotemComponent, {
              panelClass: 'info-dialog',
              disableClose: true,
              data: { method: method.method, methodUser: method.methodUser, order: result.data.order.id },
            });
          }
        })
      }
    })
  }

  openInfoCard(msg: string, close: boolean = false) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: msg,
        btnCancel: false
      }
    });
    if (close) {
      dialogRef.afterClosed().subscribe({
        next: () => {
          location.reload();
        }
      })
    }
  }

  getInvoice() {
    this.shoppingCartUser.forEach(event => {
      event.options.forEach(option => {
        option.tickets.forEach(element => {
          let line = this.invoiceLines.find(value => value.id_event_citylok == event.id && value.id_ticket == element.ticket.id && value.price_unit == element.priceTotal && value.discount == element.discount);
          if (line) {
            line.quantity++;
          }
          if (!line) {
            let fees = 0;
            if (!event.assumeFees && !(this.profile?.protocolo && this.organizerEvents?.includes(event.id))) {
              fees = event.fees || 1;
            }
            let price = element.price - element.discount;
            this.invoiceLines.push({
              "id_ticket": element.ticket.id,
              "description": element.ticket.nombre,
              "quantity": 1,
              "price_unit": +(Math.round(price * 100) / 100).toFixed(2),
              "discount": element.discount,
              "name_discount": element.discountName || "",
              "id_event_citylok": event.id,
              "fee": +(Math.round(fees * 100) / 100).toFixed(2)
            });
          }
        });
      });
    });
  }

  openDialogInfo() {
    this.dialog.open(InfoConditionsComponent, {
      panelClass: ['info-dialog', 'terms-dialog'],
      data: {
        text: null,
      },
      autoFocus: false
    });
  }

  openDialogCompanyConditions() {
    this.dialog.open(InfoConditionsComponent, {
      panelClass: ['info-dialog', 'terms-dialog'],
      data: {
        text: this.companyGeneralConditions,
      },
      autoFocus: false
    });
  }

  confirmClearCart() {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
      data: {
        icon: true,
        text: '¿Estás seguro de que quieres vaciar el carrito? Se eliminarán todas las entradas.',
        btnCancel: true,
        warning: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) this.clearShoppingCart();
    });
  }

  clearShoppingCart() {
    this.subscribeClear = this.shoppingCartService.deleteCart(this.cart.id).subscribe({
      next: () => {
        this.checkCartBooking();
      }, error: (err) => {
        this.openInfoCard('No se ha podido vaciar el carrito. Por favor, inténtalo de nuevo más tarde.', false);
      }
    })
  }

  ngOnDestroy() {
    this.subscriber?.unsubscribe();
    this.subscriberPrice?.unsubscribe();
    this.subscriberUser?.unsubscribe();
    this.subscribeClear?.unsubscribe();
    this.subscriptionCountDown?.unsubscribe();
    this.subscribeDelete?.unsubscribe();
  }

  // TrackBy functions para optimizar renderizado de listas
  trackByEventId(index: number, event: any): any {
    return event.id_event;
  }

  trackBySessionId(index: number, line: any): any {
    return line.session?.id || index;
  }

  trackByTicketId(index: number, ticket: any): any {
    return ticket.id_line;
  }

}
